<dx-data-grid biz-grid
    [selection]='{ mode: "single" }'
    [dataSource]='configs'
    [bizSetColumnChooser]="false"
    [bizSetGroupPanel]="false"
    [bizSetAllowColumnReordering]="false"
    (onRowUpdating)="onRowUpdating($event)"
    (onRowRemoving)="onRowRemoving($event)"
    [bizEditRowOnDoubleClick]="true">

    <dxo-editing mode="row" [allowUpdating]="allowUpdating" [allowAdding]="false" [allowDeleting]="allowDeleting">
    </dxo-editing>

    <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

    <dxi-column dataField="Name" dataType="string" sortOrder="asc">
        <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column dataField="ShowTrackingFields" dataType="boolean">
    </dxi-column>

    <dxi-column dataField="IsSystemConfiguration" caption="System Config" dataType="boolean" [allowEditing]="false" [visible]="false">
    </dxi-column>

    <dxi-column dataField="IsDefault" caption="Default" dataType="boolean" [calculateCellValue]="checkIsDefault"></dxi-column>

    <dxi-column dataField="CreatedBy" dataType="string" [allowEditing]="false" [visible]="false">
        <dxo-lookup [dataSource]="gridusers" valueExpr="UserId" displayExpr="DisplayName"></dxo-lookup>
    </dxi-column>

    <dxi-column dataField="CreatedDate" caption="Created" [format]="dateTimeService.getDevExpressDateTimeFunction" dataType="date" [allowEditing]="false">
        <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column dataField="UpdatedDate" caption="Updated" [format]="dateTimeService.getDevExpressDateTimeFunction" dataType="date" [allowEditing]="false">
    </dxi-column>

    <dxi-column type="buttons">
        <dxi-button name="edit"></dxi-button>
        <dxi-button name="delete"></dxi-button>
        <dxi-button text="Show Log" template="logTemplate" [visible]="allowShowLog"></dxi-button>
    </dxi-column>

    <ng-container *dxTemplate="let cell of 'logTemplate'">
        <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Log for ' + cell.data.Name" [showIcon]="false" classNames="dx-link">
            <app-change-log-link-entity type="GridConfiguration" [id]="cell.data.Id"></app-change-log-link-entity>
        </app-change-log-link>
    </ng-container>

    </dx-data-grid>
